import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '../../routes/useLanguageSync';
import { ReactComponent as Logo } from '../../assets/images/logo-with-slogen.svg';
import BlobDecoration from '../BlobDecoration/BlobDecoration';
import styles from './HeroSection.module.css';

const HeroSection: React.FC = () => {
  const { t } = useTranslation();
  const getPath = useLocalizedPath();

  return (
    <section className={styles.hero}>
      <BlobDecoration color="red" position="top-left" size="lg" />
      <BlobDecoration color="green" position="top-right" size="lg" />
      <BlobDecoration color="blue" position="bottom-left" size="md" />
      <BlobDecoration color="yellow" position="bottom-right" size="lg" />

      <div className={styles.content}>
        <Logo className={styles.logo} />
        <div className={styles.ctas}>
          <Link to={getPath('serviceDetail', { slug: 'rehab' })} className={`${styles.cta} ${styles.ctaRehab}`}>
            {t('hero.cta.rehab')}
          </Link>
          <Link to={getPath('serviceDetail', { slug: 'menhely' })} className={`${styles.cta} ${styles.ctaMenhely}`}>
            {t('hero.cta.menhely')}
          </Link>
          <Link to={getPath('serviceDetail', { slug: 'gazdi' })} className={`${styles.cta} ${styles.ctaGazdi}`}>
            {t('hero.cta.gazdi')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
